import { observer } from 'mobx-react-lite';
import PageLabelItemList from './PageLabelItemList';
import type { PageLabelItemListProps, PageLabelItemListValueProps } from './types';

export type { PageLabelItemListProps, PageLabelItemListValueProps };
export default observer(PageLabelItemList); // MANUAL OVERRIDE
